import React from "react";
import { Box, Grid, Paper } from "@mui/material";
import styled from "styled-components";
import Flex from "../../components/flex";
import Div from "../../components/div";

const H1 = styled.h1`
    font-size: 24px;
    margin: 0;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
    text-transform: uppercase;
`;

const H2 = styled.h2`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const ListTextItem = styled.li`
    font-size: 13px;
    font-weight: 300;
`;

const DivBackground = styled(Div)`
    background-color: ${({ theme }) => theme.palette.background.default};
    height: 100%;
    width: 100%;
    border-bottom-left-radius: 8px;
`;

const UpgradeCard = ({ listStartItem, listItems, title, subtitle, pricingItems, Action }) => (
    <Paper
        style={{
            position: "relative",
            borderRadius: "8px",
            width: "400px",
            maxWidth: "80vw",
            minWidth: "200px",
            height: "380px",
            minHeight: "350px",
            maxHeight: "38vh",
        }}
    >
        <div
            style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                height: "102px",
                width: "102px",
            }}
        >
            <DivBackground>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ height: "100%" }}
                >
                    {pricingItems.map((PricingItem, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Grid item key={`${title}-pricing-${index}`}>
                            <PricingItem />
                        </Grid>
                    ))}
                </Grid>
            </DivBackground>
        </div>
        <Box p={5} height="100%">
            <Grid
                container
                spacing={2}
                justifyContent="space-between"
                direction="column"
                wrap="nowrap"
                style={{ height: "100%" }}
            >
                <Grid item>
                    <H1>{title}</H1>
                    <H2>{subtitle}</H2>
                </Grid>
                <Grid item>
                    {listStartItem && (
                        <span
                            style={{
                                fontSize: "15px",
                                fontWeight: 500,
                                lineHeight: 2,
                            }}
                        >
                            {listStartItem}
                        </span>
                    )}
                    <ul style={{ paddingLeft: "20px", lineHeight: 2 }}>
                        {listItems.map((listItem, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <ListTextItem key={`${title}-listItem-${index}`}>
                                {listItem}
                            </ListTextItem>
                        ))}
                    </ul>
                </Grid>
                <Grid item style={{ paddingTop: "0px" }}>
                    <Flex justifyContent="center">
                        <Action />
                    </Flex>
                </Grid>
            </Grid>
        </Box>
    </Paper>
);

export default UpgradeCard;
